import { Briefcase02 } from "Icons/Briefcase02";
import { FileHeart02Icon } from "Icons/FileHeart02";
import { Star04Icon } from "Icons/Star04";
import { Users02Icon } from "Icons/Users02";

import { SerializedStyles, css } from "@emotion/react";

import { blue, green, pink, yellow } from "constants/colors";

const style = {
  wrapper: css({
    display: "flex",
    gap: 16,
  }),
  container: css({
    borderRadius: 16,
    width: 44,
    height: 44,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),
  starContainer: css({
    border: `4px solid ${green[300]}`,
    background: green[100],
  }),
  fileHeartContainer: css({
    border: `4px solid ${pink[300]}`,
    background: pink[100],
  }),
  briefCaseContainer: css({
    border: `4px solid ${blue[300]}`,
    background: blue[100],
  }),
  userIconContainer: css({
    border: `4px solid ${yellow[400]}`,
    background: yellow[100],
  }),
};

type Props = {
  customCss?: SerializedStyles;
};

export const BrandSquares = ({ customCss }: Props) => {
  return (
    <div css={[style.wrapper, customCss]}>
      <div css={[style.container, style.starContainer]}>
        <Star04Icon stroke={green[700]} height={20} width={20} />
      </div>
      <div css={[style.container, style.briefCaseContainer]}>
        <Briefcase02 stroke={blue[700]} />
      </div>
      <div css={[style.container, style.fileHeartContainer]}>
        <FileHeart02Icon stroke={pink[600]} />
      </div>
      <div css={[style.container, style.userIconContainer]}>
        <Users02Icon stroke={yellow[900]} />
      </div>
    </div>
  );
};
